export class ChangedProperties {
    configurationEntityType: ConfigurationEntitiyType;
    configurationEntityId: number;
    properties: { [key: string]: string }
}

export enum ConfigurationEntitiyType {
    SSID = "Ssid",
    VLAN = "Vlan"
}